<p-toast></p-toast>
<p-confirmDialog [style]="{minWidth: '40vw'}" position="top" [baseZIndex]="10000" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<div class="grid">
    <div class="col-12">
        <div class="card">
			<h5>Informe de Notificaciones</h5>
            <hr>
            <form *ngIf="formGroup" [formGroup]="formGroup" (ngSubmit)="ejecutar()">
                <div class="p-fluid p-formgrid grid">
                    <ng-container *ngIf="currentUser.superusuario">
                        <div class="field col-12 md:col-1">
                            <label htmlFor="id_empresa">Empresa</label>
                            <span class="p-input-icon-right">
                                <input pInputText id="id_empresa" type="text" formControlName="id_empresa" (change)="onEmpresa()" (keydown.control.enter)="onListaEmpresa()"/>
                                <i  style="font-size: 1.2rem;" class="pi pi-search" (click)="onListaEmpresa()"></i>
                            </span>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="nombre_empresa">Descripción</label>
                            <input pInputText id="nombre_empresa" type="text" formControlName="nombre_empresa" readonly />
                        </div>
                    </ng-container>
                    <div class="field col-12 md:col-2">
                        <label htmlFor="fecha_desde">Fecha Desde</label>
                        <p-calendar id="fecha_desde" formControlName="fecha_desde" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                    <div class="field col-12 md:col-2">
                        <label htmlFor="fecha_hasta">Fecha Hasta</label>
                        <p-calendar id="fecha_hasta" formControlName="fecha_hasta" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                    <div class="field col-12 md:col-2">
                        <label htmlFor="tipo">Tipo</label>
                        <p-dropdown [options]="tipos" formControlName="tipo" optionLabel="nombre" optionValue="valor" ></p-dropdown>
                    </div>
                </div>
                <div class="grid">
                    <div class="col-12 md:col-2">
                        <button pButton pRipple type="submit" label="Ejecutar" icon="pi pi-check" class="p-button-info mr-2" pTooltip="Ejecutar"></button>
                    </div>
                    <ng-container *ngIf="items?.length">
                        <div class="col-12 md:col-2">
                            <button pButton pRipple class="p-button-warning" label="Imprimir" icon="pi pi-print" (click)="descargar()"></button>
                        </div>
                        <div class="col-12 md:col-2">
                            <button pButton pRipple class="p-button-success" label="Descargar" icon="pi pi-file-excel" (click)="descargarExcel()"></button>
                        </div>
                    </ng-container>
                </div>
            </form>
            <p-table styleClass="p-datatable-sm p-datatable-gridlines" [value]="items" [loading]="loading" dataKey="id" responsiveLayout="scroll" rowHover="true"
            [showCurrentPageReport]="true" [paginator]="true" [rows]="15" currentPageReportTemplate="Mostrando {first} a {last} de {{items.length}} entradas">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="cabecera align-center" pSortableColumn="fecha">Fecha<p-sortIcon field="fecha"></p-sortIcon></th>
                        <th class="cabecera align-left" pSortableColumn="nombre">Titulo<p-sortIcon field="nombre"></p-sortIcon></th>
                        <th class="cabecera align-left" pSortableColumn="descripcion">Descripcion<p-sortIcon field="descripcion"></p-sortIcon></th>
                        <th class="cabecera align-center" pSortableColumn="canal">Canal<p-sortIcon field="canal"></p-sortIcon></th>
                        <th class="cabecera align-center" pSortableColumn="origen">Origen<p-sortIcon field="origen"></p-sortIcon></th>
                        <th class="cabecera align-center" pSortableColumn="codigo_usuario">Codigo de Usuario<p-sortIcon field="codigo_usuario"></p-sortIcon></th>
                        <th class="cabecera align-center" pSortableColumn="total_enviado">Cantidad Enviada<p-sortIcon field="total_enviado"></p-sortIcon></th>
                        <th class="cabecera align-center" pSortableColumn="total_no_enviado">No Enviados<p-sortIcon field="total_no_enviado"></p-sortIcon></th>
                        <th class="cabecera align-center" pSortableColumn="total_pendiente">Pendientes<p-sortIcon field="total_pendiente"></p-sortIcon></th>
                        <th class="cabecera align-center" pSortableColumn="costo_unitario">Costo Unitario<p-sortIcon field="costo_unitario"></p-sortIcon></th>
                        <th class="cabecera align-center" pSortableColumn="monto_total">Monto Total<p-sortIcon field="monto_total"></p-sortIcon></th>
                        <th class="cabecera align-center">Acciones</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item let-expanded="expanded">
                    <tr class="p-0 m-0">
                        <td class="align-center">{{ item.fecha | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                        <td class="align-left text-normal">{{ item.nombre }}</td>
                        <td class="align-left text-normal">{{ item.descripcion }}</td>
                        <td class="align-center">{{ item.canal }}</td>
                        <td class="align-center">{{ item.origen }}</td>
                        <td class="align-center">{{ item.codigo_usuario || '-' }}</td>
                        <td class="align-monto"><b>{{ item.total_enviado | number: '1.0-0':'es-PY' }}</b></td>
                        <td class="align-monto"><b>{{ item.total_no_enviado | number: '1.0-0':'es-PY' }}</b></td>
                        <td class="align-monto"><b>{{ item.total_pendiente | number: '1.0-0':'es-PY' }}</b></td>
                        <td class="align-monto"><b>{{ item.costo_unitario | currency: '':'':'1.0-2':'es-PY' }}</b></td>
                        <td class="align-monto"><b>{{ item.monto_total | currency: '':'':'1.0-2':'es-PY' }}</b></td>
                        <td class="align-center">
                            <button *ngIf="canVerDetalle(item)" pButton pRipple type="button" class="p-button-text p-button-info p-button-sm" icon="pi pi-list" label="Ver detalle" (click)="verDetalle(item)"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                    <tr>
                        <td class="cabecera-detalle" colspan="6">TOTALES</td>
                        <td class="cabecera-detalle align-monto"><b>{{ totalEnviado | number: '1.0-0':'es-PY' }}</b></td>
                        <td class="cabecera-detalle align-monto"><b>{{ totalNoEnviado | number: '1.0-0':'es-PY' }}</b></td>
                        <td class="cabecera-detalle align-monto"><b>{{ totalPendiente | number: '1.0-0':'es-PY' }}</b></td>
                        <td class="cabecera-detalle align-monto"></td>
                        <td class="cabecera-detalle align-monto"><b>{{ totalImporte | currency: '':'':'1.0-2':'es-PY' }}</b></td>
                        <td class="cabecera-detalle align-center"></td>
                    </tr>
                </ng-template>
            </p-table>
            <div class="chart-wrapper" *ngIf="chartData">
                <div class="chart-header">
                    <h6 class="m-0">Evolución diaria del volumen e importe</h6>
                    <small class="text-600">Compará cuándo se concentró el envío y cuánto impactó en importe dentro del período filtrado.</small>
                </div>
                <div class="chart-body">
                    <p-chart type="bar" [data]="chartData" [options]="chartOptions"></p-chart>
                </div>
            </div>
        </div>
    </div>
</div>

<app-on-lista [show]="showOnLista" [title]="tituloOnLista" [columns]="columnasOnLista" [service]="serviceOnLista" [recordName]="recordNameOnLista" [filters]="filters"
    (close)="cerrarOnLista($event)">
</app-on-lista>

<p-dialog [(visible)]="showDialogDetalle" position="center" modal="true" header="Detalle de notificación" [breakpoints]="{'960px': '90vw', '400px': '98vw'}" [style]="{width: '85vw'}" [closeOnEscape]="true">
    <div class="detalle-header" *ngIf="selectedInformeDetalle">
        <div>
            <h6 class="m-0">{{ selectedInformeDetalle.nombre }}</h6>
            <small class="text-600">{{ selectedInformeDetalle.fecha | date: 'dd/MM/yyyy HH:mm:ss' }} · {{ selectedInformeDetalle.canal }}</small>
        </div>
        <div class="detalle-totales">
            <span class="p-tag p-tag-success">Enviados: {{ selectedInformeDetalle.total_enviado | number: '1.0-0':'es-PY' }}</span>
            <span class="p-tag p-tag-danger">No enviados: {{ selectedInformeDetalle.total_no_enviado | number: '1.0-0':'es-PY' }}</span>
            <span class="p-tag p-tag-warning">Pendientes: {{ selectedInformeDetalle.total_pendiente | number: '1.0-0':'es-PY' }}</span>
        </div>
    </div>

    <div class="p-fluid p-formgrid grid mt-3" [formGroup]="detalleFormGroup">
        <div class="field col-12 md:col-3">
            <label htmlFor="detalle_estado">Estado</label>
            <p-dropdown id="detalle_estado" [options]="detalleEstadoOptions" formControlName="estado" optionLabel="label" optionValue="value" (onChange)="onDetalleEstadoChange()"></p-dropdown>
        </div>
        <div class="field col-12 md:col-5">
            <label htmlFor="detalle_busqueda">Buscar</label>
            <input pInputText id="detalle_busqueda" type="text" formControlName="busqueda" placeholder="Teléfono o destinatario" (keydown.enter)="cargarDetalleNotificacion()" />
        </div>
        <div class="field col-12 md:col-4 detalle-actions">
            <button pButton pRipple type="button" class="p-button-info mr-2" label="Buscar" icon="pi pi-search" (click)="cargarDetalleNotificacion()"></button>
            <button pButton pRipple type="button" class="p-button-secondary p-button-outlined" label="Limpiar" icon="pi pi-times" (click)="limpiarBusquedaDetalle()"></button>
        </div>
    </div>

    <!-- Reenvio manual: al retomar una campania los fallidos NO se reintentan
         solos, porque un numero invalido va a fallar siempre y un corte de Meta
         no. Esa diferencia la decide una persona mirando el motivo. -->
    <div class="flex justify-content-end align-items-center gap-3 mb-2" *ngIf="haySeleccionParaReenviar">
        <small class="text-600">{{ seleccionReenvio.length }} seleccionado(s). Se reenvía con el mismo mensaje original.</small>
        <button pButton pRipple type="button" class="p-button-sm" icon="pi pi-send"
                label="Reenviar seleccionados" [loading]="reenviando"
                (click)="onReenviarSeleccionados()"></button>
    </div>

    <p-table styleClass="p-datatable-sm p-datatable-gridlines" [value]="detalleItems" [loading]="loadingDetalle" responsiveLayout="scroll" rowHover="true"
        dataKey="destinatario_telefono" [(selection)]="seleccionReenvio"
        [showCurrentPageReport]="true" [paginator]="true" [rows]="10" currentPageReportTemplate="Mostrando {first} a {last} de {{detalleTotal}} entradas">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 3rem"></th>
                <th class="cabecera align-left" pSortableColumn="destinatario_telefono">Destinatario / Teléfono<p-sortIcon field="destinatario_telefono"></p-sortIcon></th>
                <th class="cabecera align-center" pSortableColumn="estado_negocio">Estado cliente<p-sortIcon field="estado_negocio"></p-sortIcon></th>
                <th class="cabecera align-left" pSortableColumn="error">Motivo / observación<p-sortIcon field="error"></p-sortIcon></th>
                <th class="cabecera align-center" pSortableColumn="fecha">Fecha<p-sortIcon field="fecha"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-detalle>
            <tr>
                <td>
                    <!-- Solo lo que no llego: reenviar un mensaje que si llego
                         se lo mandaria dos veces al cliente. -->
                    <p-tableCheckbox *ngIf="esReenviable(detalle)" [value]="detalle"></p-tableCheckbox>
                </td>
                <td class="align-left text-normal">{{ detalle.destinatario_telefono || '-' }}</td>
                <td class="align-center"><span class="p-tag p-tag-sm" [ngClass]="getDetalleEstadoClass(detalle.estado)">{{ detalle.estado_negocio || getDetalleEstadoLabel(detalle.estado) }}</span></td>
                <td class="align-left text-normal error-cell">{{ detalle.error || '-' }}</td>
                <td class="align-center">{{ detalle.fecha | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" class="align-center">Sin detalle para mostrar</td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>
